import { api } from '@/f1/service';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};

export default {
  components : { cSwitch, Language },
  data : () => {
    return {
      confirm: false,
      add: false,
      lock: true,
      model : { group: {}, code : '' },
    }
  },
  computed: {
    i18n_data() { return _i18n_data; }
  },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel() { this.$router.replace({ name: 'wmds_pattern', params: { id: this.model.id }}) },
    edit() { this.$router.replace({ name: 'wmds_pattern', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try{
        await api.wmds.WMDS_Call('pattern', 'delete', {id :this.model.id})
        this.$parent.$emit('refresh'), this.$toastr.s(this.i18n_data['removed'][this.i18n]), this.list()
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_pattern'}); },
    async save() {
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Code required'); }
      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {
        let rs = await api.wmds.WMDS_Call('pattern', this.model.id ? 'update' : 'insert', this.model);
        if(rs.error) { return this.$toastr.e("save failed") }


        this.$toastr.s(this.i18n_data['saved'][this.i18n]);
        this.$parent.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('pattern.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_alive: true, level: 'W', type: 'U' }; return; }
      try{
        this.add = false;
        this.lock = (tag !== 'edit');
        let rs = await api.wmds.WMDS_Call('pattern', 'detail', { id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('pattern.detail.vue', 'created'); },
  destroyed() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
